<template>
  <div class="main-content">
    <the-header :title="t('Edit application')">
      <template slot="buttons">
        &nbsp; <!-- Do not delete  -->
        <template v-if="showButtons">
          <client-side-download-button :application="this.application"/>
          <!--          <download-button :link="application.downloadLink" />-->
          <signed-document-upload
            v-if="this.application.patient.insurance.code !== null && this.application.patient.insurance.code === 25 && this.showSignedDocUpload"
            :application="this.application"/>
        </template>
      </template>
    </the-header>
    <div class="text-center" v-if="loading === true">
      <loading/>
    </div>
    <template v-if="loading === false">
      <standard-alert type="success"
                      v-if="loading === false && application.status.slug !== 'concept' && application.submitDate === null"
                      :text="t('Application was created. You can download the application or send it to insurance.')"
      />
      <standard-alert type="success"
                      v-if="loading === false && application.status.slug !== 'concept' && application.submitDate !== null"
                      :text="t('Application was created. You can download the application or check history of email communication.')"
      />
      <standard-alert type="primary"
                      v-if="loading === false && application.status.slug === 'concept'"
                      :text="t('Fill form and finish application')"
      />
      <mail-list ref="mailList" :application-id="parseInt(application.id)"
                 v-if="application.id !== undefined && application.patient.insurance.code === 25 && showButtons && application.submitDate !== null"
      />
      <div :class="{'d-none': showEditForm === false}">
        <patient-form v-if="appForm === 'GENERAL'"
                      ref="patientForm"
                      @saveData="saveData()"
                      @validate="isValid()"
                      :formData="application.patient"
                      :editable="hasPermission('ApplicationsTitan', 'U') && !accepted"
        />
        <cardio-app-form v-if="appForm === 'GENERAL'" ref="applicationForm"
                         @saveData="saveData()"
                         @validate="isValid()"
                         @openPrescription="$refs.prescriptionModal.open()"
                         @reload="initData"
                         :accepted="accepted"
                         :formData="application"
        />
        <derma-app-form v-if="appForm === 'PSORIASIS'" ref="applicationForm"
                        @saveData="saveData()"
                        @validate="isValid()"
                        @openPrescription="$refs.prescriptionModal.open()"
                        @reload="initData"
                        :accepted="accepted"
                        :formData="application"
        />
        <hema-form v-if="appForm === 'HEMA'" ref="applicationForm"
                          @saveData="saveData()"
                          @validate="isValid()"
                          @openPrescription="$refs.prescriptionModal.open()"
                          @reload="initData"
                          :accepted="accepted"
                          :formData="application"
        />
        <prescription ref="prescriptionModal"
                      :id="application.id"
                      :prescribed="application.prescribed"
                      :approved="application.approvedPackages"
                      @added="initData()"
        />
      </div>
    </template>
  </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import CardioAppForm from './cardio-form';
    import DermaAppForm from './derma-form';
    import HemaForm from './hema-form';
    import PatientForm from '../patients/form';
    import AcceptAction from '../../../core/AcceptAction';
    import StandardAlert from '../../../components/standard-alert';
    import {validateMultipleForms} from '../../../core/Libs/utils';
    import Loading from '../../../core/Components/loading';
    import SendApplication from './send-application';
    import DownloadButton from './download-button';
    import ClientSideDownloadButton from './client-side-download-button';
    import SignedDocumentUpload from './signed-document-upload';
    import Prescription from './prescription';
    import MailList from '../../../components/mail-list';

    export default {
        components: {
            Prescription,
            DownloadButton,
            ClientSideDownloadButton,
            SignedDocumentUpload,
            SendApplication,
            Loading,
            TheHeader,
            CardioAppForm,
            DermaAppForm,
            HemaForm,
            PatientForm,
            AcceptAction,
            StandardAlert,
            MailList,
        },
        created() {
            this.showSignedDocUpload = (document.location.host === 'dev-mendel.ceeor.com' || [21, 50, 60, 64, 8, 106, 198].includes(this.$parent.account.id))
        },
        mounted() {
            this.initData();
            this.panelId = this.panel !== null ? this.panel.id : 0;
            // switch (this.panelId) {
            //     case 0:
            //     case 1: this.appForm = 'Cardio'; break
            //     case 2: this.appForm = 'Derma'; break
            // }
        },
        computed: {
            protocol() {
                if (this.loading === false) {
                    return this.application.protocol
                } else {
                    return null;
                }
            },
            appForm() {
                let appForm = null;
                if (this.protocol === null) {
                    appForm = null;
                } else {
                    switch (this.protocol.id) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            appForm = 'GENERAL';
                            break;
                        case 5:
                        case 6:
                            appForm = 'PSORIASIS';
                            break;
                        case 7:
                        case 8:
                            // appForm = 'CLL/NHL';
                            // break;
                        case 9:
                        case 10:
                            // appForm = 'MYELO-LEUK';
                            // break;
                        case 11:
                        case 12:
                        case 13:
                            // appForm = 'MULTI-MYELOMA';
                            // break;
                            appForm = 'HEMA';
                            break;
                    }
                }
                return appForm;
            },
            panel() {
                return this.$store.getters['account/account'].panel;
            },
            showButtons() {
                return false === this.loading &&
                    this.application !== undefined &&
                    this.application.status !== null &&
                    this.application.status.slug !== 'concept';
            },
            showEditForm() {
                return this.showForm;
            },
            application() {
                return this.$store.state.applications.item;
            },
            accepted() {
                return this.application.status !== undefined && 'accepted' === this.application.status.slug;
            },
        },
        watch: {
            '$route.params.id'() {
                this.initData();
            },
        },
        methods: {
            initData() {
                this.$store.commit('applications/setItem', {});
                this.loadApplications();
            },
            loadApplications() {
                this.loading = true;
                return this.$store.dispatch('applications/get', this.$route.params.id).then(() => {
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            isValid(showError = true) {
                const valid = validateMultipleForms([this.$refs.patientForm, this.$refs.applicationForm]);
                if (false === valid && true === showError) {
                    this.$store.dispatch('alert/warning', this.t('Form has invalid data. Check it and try again.'));
                }
                return valid;
            },
            saveData() {
                if (true === this.isValid(false)) {
                    this.loading = true;
                    this.$store.dispatch('applications/update', this.$store.state.applications.item).then(() => {
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            },
        },
        data() {
            return {
                //appForm: null,
                panelId: 0,
                showForm: true,
                loading: true,
            }
        },
    }
</script>

<style lang="scss">
  .second-button {
    margin-bottom: 20px;
  }

  .card-collapse {
    padding: 0;

    .titan-form {
      width: 100%;
    }

    .card {
      margin-bottom: 0;
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/manage.vue